/**
 * @module app.cm
 */

import * as CM from 'app/cm/models/essette-api';
import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { CaseService } from 'app/cm/services/case-service';
import { I18N } from 'aurelia-i18n';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { IHouseholdCaseSummaryModelData } from 'app/cm/components/summary/household-case-summary';

@autoinject()
export class HouseholdCaseSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    private householdCase: CM.HouseholdCase | null = null;
    protected modelData: IHouseholdCaseSummaryModelData | null = null;


    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly caseService: CaseService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
    }

    protected async activate(params: { householdCaseId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.householdCaseId) { throw new Error('Missing required parameters: householdCaseId'); }

        await this.reload(params.householdCaseId);

        if(this.householdCase && routeConfig.navModel) {
            const title = this.i18n.tr('cm:routes.household-case.summary.$title', { number: this.householdCase.number });
            routeConfig.navModel.setTitle(title);
        }
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    public async reload(householdCaseId: string): Promise<void> {
        if(householdCaseId) {
            await this.loadHouseholdCase(householdCaseId);

            if(!this.householdCase) {
                throw new Error('Unable to load household case');
            }

            this.modelData = {
                householdCaseId: householdCaseId || '',
                readonly: true
            };
        }
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    private async loadHouseholdCase(householdCaseId: string): Promise<void> {
        try {
            this.state.beginLoad();

            const response = await this.caseService.loadHouseholdCase(householdCaseId);
            this.householdCase = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }

}
